import { Box } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useParametrizationConfigTolerancia from '@hook/parametrization/use-config-tolerancia'
import useAuth from '@hook/shared/use-auth'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarReabCronPurchaseTolerancia from '@component/Parameterization/cronPurchase/SelectedTableBarTolerancia'

import cronPurchaseTolerancia from '@base/variables/headers/cronograma-purchase/cron-purchase-tolerancia'

const PurchaseCronToleranciaConfig: FC = () => {
  const { menuToggle } = useLayout()
  const {
    loadingTolerancias,
    dataTolerancias: data = [],
    pagination,
    filters,
    fetching,
    query,
    tableInteractionTolerancia,
    companieId,
    actionsTolerancia,
    setFilename,
    setQuery
  } = useParametrizationConfigTolerancia()

  const { companies: authCompanies = [] } = useAuth()
  const { hasSessions } = useSessions()

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  const shouldShowSelectedTableBar =
    authCompanies?.length === 0 ||
    (authCompanies?.length > 1 && companieId === '') ||
    loadingTolerancias

  return (
    <Box mW={400}>
      <LayoutTools
        title={'Cronograma Compra - Tolerância'}
        filters={filters}
        actions={actionsTolerancia}
        query={query}
        onSearchChange={setQuery}
        onTitleChange={setFilename}
        isDisabled={loadingTolerancias || fetching || data.length === 0}
      />
      {/* Renderiza a barra somente quando há empresa(s) válida(s) selecionadas */}
      {!shouldShowSelectedTableBar && (
        <SelectedTableBarReabCronPurchaseTolerancia />
      )}

      {loadingTolerancias ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : authCompanies?.length === 0 ? (
        <LayoutEmpty
          type="chartEmpty"
          title="É necessário pelo menos 1 empresa cadastrada no perfil"
          message=""
        />
      ) : authCompanies?.length > 1 && companieId === '' ? (
        <LayoutEmpty
          type="chartEmpty"
          title="Selecione ao menos 1 empresa"
          message="Filtre sua busca em cima para obter informações"
        />
      ) : data.length === 0 ? (
        <LayoutEmpty
          title="Nada encontrado!"
          message="Filtre sua busca ao lado para obter informações"
        />
      ) : (
        <Box>
          <Box paddingLeft={2}>
            <GridQuantity data={data} />
          </Box>

          <TableGrid
            id="cron-purchase-user"
            entity="cron-purchase-user"
            headers={cronPurchaseTolerancia}
            query={query}
            data={data}
            itsSortable={true}
            loading={fetching}
            actions={tableInteractionTolerancia}
            height={tableHeight}
            pagination={pagination}
          />
        </Box>
      )}
    </Box>
  )
}

export default PurchaseCronToleranciaConfig
